<template>
   <v-card elevation="0" class="rounded-lg pa-2">
      <div class="d-flex align-center justify-space-between">
         <div class="subtitle-1 font-weight-medium">{{ $t('Materials prices') }}</div>
         <!-- <div class="subtitle-2 primary--text text-decoration-underline cursor_pointer">{{ $t('see more') }}</div> -->
      </div>
      <table class="col-12 py-1">
         <thead>
            <tr class="text-center">
               <th>{{ $t('Item') }}</th>
               <th>{{ $t('Top price') }}</th>
               <th>{{ $t('Under price') }}</th>
               <th>{{ $t('normal') }}</th>
            </tr>
         </thead>
         <tbody>
            <!-- cement -->
            <tr class="text-center" v-for="(row, index) in product_prices" :key="index">
               <td>{{ row.title }}</td>
               <td>{{ row.max_price || 0 | floatTo(0) }} {{ $t('LE') }}</td>
               <td>{{ row.min_price || 0 | floatTo(0) }} {{ $t('LE') }}</td>
               <td>{{ row.mid_price || 0 | floatTo(0) }} {{ $t('LE') }}</td>
            </tr>

            
         </tbody>
      </table>
   </v-card>
</template>

<script>

export default {
   name: 'MaterialsPrices',
   props: {
      isLoading: { default: false },
      product_prices: { default: [] },
   },
   components: {

   },
   data: () => ({

   }),
   methods: {

   }
}
</script>

<style lang="scss" scoped>
</style>